import React, { useState } from "react";
import ChoiceSystem from "../../Components/ADD_Fact_Components/choiceSystem";
import { Button } from "antd";
import { Row, Col } from "reactstrap";
import { useSelector } from "react-redux";

const Step2_add_System = (props) => {
    const lang_choiced = useSelector((state) => state.lang_change);
    const new_system = useSelector((state) => state.add_system);
    const [data , setData] = useState()
    const handleChangeData = (data) =>{
        setData(data)
    }
  return (
    <div>
      <ChoiceSystem data={handleChangeData}/>
      <Row>
        <Col className="text-right">
          <Button
            onClick={() => {
              props.validation(true);
              props.data(new_system , "step2")
            }}
            type="primary"
          >
            {lang_choiced.pages.add_fact.btnNext}
          </Button>
        </Col>
        <Col className="text-left">
          <Button
            onClick={() => {
              props.back(true);
              // props.data(new_system , "step2")
            }}
            danger
          >
            {lang_choiced.pages.add_fact.btnBack}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Step2_add_System;
